import Box from 'components/shared/Box'
import InlineTextList from 'components/shared/InlineTextList'
import OrderedTicket from 'components/shared/OrderedTicket'
import Text from 'components/shared/Text'
import { useState } from 'react'
import { useResolutions } from 'store/resolutions'
import { Color } from 'styles/types'
import TicketEditor from 'routes/selfcare/views/ManageOrder/editors/TicketEditor'
import { useSelfcare } from 'store/selfcare-slice/hooks'
import Loader from 'components/shared/Loader'
import UseTicketTranslations from 'utils/hooks/useTicketTranslations'
import { TicketReservation } from 'store/selfcare-slice/types'

interface ManagedTicketProps {
    ticket: TicketReservation
    index: number
}

const ParkTicket = ({ ticket, index }: ManagedTicketProps) => {
    const { isTablet } = useResolutions()
    const { getTicketPersonByKey, getTicketZoneByKey, getTicketTypeByKey } =
        UseTicketTranslations()

    const [isEdited, setIsEdited] = useState(false)
    const { original, changeType, changes, isActive, modificationId } = ticket
    const dataToDisplay = changes || original
    const { detail, price } = dataToDisplay || {}
    const { person, ticketTime, zone, orderTicketId } = detail || {}

    const personTitle = getTicketPersonByKey(person)
    const zoneTitle = getTicketZoneByKey(zone)
    const ticketTitle = getTicketTypeByKey(ticketTime)

    const listItems = isTablet
        ? [zoneTitle || zone, ticketTitle || ticketTime]
        : [personTitle || person, zoneTitle || zone, ticketTitle || ticketTime]

    const { deleteItem, revertDeleteItem } = useSelfcare()

    const handleDelete = () => {
        if (!orderTicketId) return

        deleteItem({ productType: 'ticket', detail: { orderTicketId } }).then(
            () => setIsEdited(false)
        )
    }

    const handleRevert = () => {
        if (!modificationId) return

        revertDeleteItem(modificationId)
    }

    let textColor: Color = 'grayscale_900'

    if (!isActive || changeType === 'return') {
        textColor = 'grayscale_700'
    }

    if (changeType === 'change') {
        textColor = 'primary_500'
    }
    const handleCancel = () => {
        setIsEdited(false)
    }

    const ticketText = (
        <Box direction="column">
            {!personTitle || !zoneTitle || !ticketTitle ? (
                <Loader />
            ) : (
                <>
                    {isTablet && (
                        <Text variant="bodySmall" color={textColor} mb={8}>
                            {personTitle}
                        </Text>
                    )}
                    <InlineTextList
                        variant="bodySmall"
                        color={textColor}
                        items={listItems}
                        hasNoWrapItems
                        gap={16}
                        dotColor={
                            isActive && changeType !== 'return'
                                ? 'primary_500'
                                : 'grayscale_700'
                        }
                    />
                </>
            )}
        </Box>
    )

    return (
        <OrderedTicket
            key={orderTicketId}
            id={orderTicketId || ''}
            items={[
                {
                    text: ticketText,
                },
            ]}
            price={price || 0}
            onDelete={handleDelete}
            isEdited={isEdited}
            setIsEdited={setIsEdited}
            isDisabled={!isActive}
            creator={
                <TicketEditor
                    ticket={ticket}
                    onCancel={handleCancel}
                    index={index}
                />
            }
            isDeleted={isActive && changeType === 'return'}
            onRevert={handleRevert}
            testIdPrefix={`selfcare-ticket-${index}`}
        />
    )
}
export default ParkTicket
